import { createContext } from "react";

// Public (giriş yapmamış/genel) sayfalardaki mobil menünün açık/kapalı
// durumunu MainNavbar (üst bar) ile PublicBottomNav (alt bar) arasında
// paylaşmak için kullanılan context. Sağlayıcı: Layouts/NonAuthLayout.jsx
export const PublicMenuContext = createContext({
 toggle: false,
 setToggle: () => {},
});
